import Vue from 'vue';
import VueRouter from 'vue-router';
import {Message} from 'element-ui'

// 进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// 公共数据
import util from '@/libs/util';

// 路由数据
import routes from './routes';

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
});

import i18n from "../i18n";

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  // 进度条
  NProgress.start();
  // 验证当前路由所有的匹配中是否需要有登录验证的
  console.log(to, from)
  if (to.matched.some(r => r.meta.auth)) {
    next();
  } else {
    //不需要身份验证，直接通过
    next();
  }
})

router.afterEach(to => {
  // 进度条
  NProgress.done();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js